import React from "react";

import {
  callToLearnMoreButtonClicked,
  contactUsButtonClicked,
} from "utils/segment";

import Container from "./Container";
import Row from "./Row";
import Col from "./Col";
import Button from "./Button";
import getStartedCall from "../assets/get-started-call.svg";
import getStartedEmail from "../assets/get-started-email.svg";
import AnthemEnroll from "containers/Forms/AnthemEnroll";

const GetStarted = ({ showForm, hideEmail, ctaLink, ctaText, hideCall }) => {
  if (showForm) {
    return (
      <div className="get-started text-center">
        <Container>
          <h2 className="ml-auto mr-auto">Ready to get started?</h2>

          <Row className="responsive-row">
            <Col md={{ span: 6, offset: 3 }}>
              <AnthemEnroll />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="get-started text-center">
      <Container>
        <h2 className="ml-auto mr-auto">Ready to get started?</h2>

        <Row className="responsive-row">
          {!hideCall &&
            <Col md={6} className="mb-30 mr-auto ml-auto">
              <img
                data-src={getStartedCall}
                alt="Call for more info"
                className="img-responsive ml-auto mr-auto lazyload"
              />
              <h4 className="mb-10">Call for more info</h4>
              <Button
                href={ctaLink ? ctaLink : "tel:+1-800-348-7951"}
                onClick={callToLearnMoreButtonClicked}
              >
                {ctaText ? ctaText : "1-800-348-7951"}
              </Button>
            </Col>
          }

          {!hideEmail && (
            <Col md={6} className="mr-auto ml-auto">
              <img
                data-src={getStartedEmail}
                alt="Call for more info"
                className="img-responsive ml-auto mr-auto lazyload"
              />
              <Button
                to="/contact-us"
                onClick={() => {
                  contactUsButtonClicked({
                    buttonCta: "Contact Us",
                    descriptionText: undefined,
                    siteDivName: "GetStarted",
                  });
                }}
              >
                Contact Us
              </Button>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default GetStarted;